module.exports = __webpack_public_path__ + "img/budget-3.58c46075.png";